import { Logger } from "./logging";
import { v4 as uuidv4 } from "uuid";

const logger = new Logger("paypal");

const IS_PROD = process.env.NODE_ENV === "production";

// One-time PayPal initialization control flag
window._isPayPalInitialized = false;

// PayPal Flow Identifier for the Page
const PAYPAL_PAGE_FLOW_ID = IS_PROD
  ? "NEXTLINE_AJTX4BUQEH73E_BA"
  : "AJTX4BUQEH73E_checkout-page";

function getPayPalSessionId() {
  return window._paypalSessionId;
}

/**
 * This function will load PayPal FraudNet configuration to the
 * page for fraud detection. Generated content for session will be passed in PAYPAL-CLIENT-METADATA-ID header each request to the PayPal.
 *
 * @see {@link https://developer.paypal.com/docs/multiparty/checkout/apm/pay-upon-invoice/fraudnet/}
 * @param {string} sessionId Session id
 * @param {string} flowId Webpage unique identifier
 */
function initialize() {
  if (window._isPayPalInitialized) {
    logger.warn("PayPal is already initialized skip initialization");
    return;
  }

  window._paypalSessionId = uuidv4().replaceAll("-", "");

  let $el = document.createElement("script");
  $el.type = "application/json";
  $el.setAttribute("fncls", "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99");

  if (IS_PROD) {
    $el.innerText = `{ "f": "${window._paypalSessionId}", "s": "${PAYPAL_PAGE_FLOW_ID}"}`;
  } else {
    $el.innerText = `{ "f": "${window._paypalSessionId}", "s": "${PAYPAL_PAGE_FLOW_ID}", "sandbox": true}`;
  }

  document.body.appendChild($el);

  $el = document.createElement("script");
  $el.type = "text/javascript";
  $el.src = "https://c.paypal.com/da/r/fb.js";
  document.body.appendChild($el);

  window._isPayPalInitialized = true;
}

export default { initialize, getPayPalSessionId, PAYPAL_PAGE_FLOW_ID };
